import React from "react";
import {ButtonLayout, NegativeButtons, PositiveButtons} from "../button/ButtonLayout";
import {CancelButton} from "../button/CancelButton";
import DialogTitle from "./DialogTitle";
import Dialog from "./Dialog";
import DialogContent from "./DialogContent";
import DialogActions from "./DialogActions";
import DialogContentText from "./DialogContentText";
import {DeleteButton} from "../button/DeleteButton";
import Alert from "@mui/material/Alert";
import {Stack} from "@mui/material";

export interface DeleteConfirmationDialogProps {
    open: boolean;
    title: string;
    confirmationText: string;
    errorText?: string;
    deleteDisabled?: boolean;
    onDelete: () => void;
    onClose: () => void;
}

export default function DeleteConfirmationDialog(props: Readonly<DeleteConfirmationDialogProps>) {

    const {open, title, confirmationText, errorText, deleteDisabled, onDelete, onClose} = props;

    return (
        <Dialog open={open}
                onClose={onClose} >
            <DialogTitle title={title} onDialogClosed={onClose}/>
            <DialogContent>
                <Stack spacing={1}>
                    <DialogContentText>
                        {confirmationText}
                    </DialogContentText>

                    {errorText !== undefined &&
                        <Alert severity={"error"}>
                            {errorText}
                        </Alert>
                    }
                </Stack>
            </DialogContent>
            <DialogActions>
                <ButtonLayout>
                    <PositiveButtons>
                        <DeleteButton onClick={onDelete} disabled={deleteDisabled} />
                    </PositiveButtons>
                    <NegativeButtons>
                        <CancelButton onClick={onClose} />
                    </NegativeButtons>
                </ButtonLayout>
            </DialogActions>
        </Dialog>
    )
}
